import { CONTACT_DETAILS_TAB_LIST } from '../pages/contact/contactDetails/contactDetailsTabs';
import { ACCOUNT_DETAILS_TAB_LIST } from '../pages/account/accountDetails/accountDetailsTabs';
import { TRIP_DETAILS_TAB_LIST } from '../pages/trip/tripDetails/tripDetailsTabs';
import { JETCARD_LIST_TABS } from '../pages/jet-card/jetCardListTabs';
import { TASK_LIST_TABS } from '../pages/tasks/taskListTabs';
import { CALENDAR_VIEW_PATH, CALENDAR_VIEW } from '../pages/calendar/calendarViews';

export const ROUTE_URLS = {
  MOBILE_APP: '/mobile-app',
  EMBED_JETCARD: '/embed/jetcard',
  EMBED_OPPORTUNITY: '/embed/opportunity',
  EMBED_TRIP: '/embed/trip',
  DASHBOARD: '/dashboard',
  FINANCE_TRIP_ADMINISTRATION: '/finance/trip',
  CONTACT_LIST: '/contacts-list',
  ACCOUNTS: '/accounts',
  AIRCRAFTS_LIST: '/aircrafts-list',
  OPERATORS_LIST: '/operators-list',
  FBO_LIST: '/fbo-list',
  AIRPORTS_LIST: '/airports-list',
  JETCARD_LIST: '/jetcard-list',
  JETCARDS: '/jetcards',
  JETCARDS_PROMOTIONS: `/jetcards/${JETCARD_LIST_TABS.PROMOTIONS}`,
  JETCARDS_ADDITIONAL_TERMS: `/jetcards/${JETCARD_LIST_TABS.ADDITIONAL_TERMS}`,
  JETCARDS_PROMOTIONAL_TERMS: `/jetcards/${JETCARD_LIST_TABS.PROMOTIONAL_TERMS}`,
  JETCARDS_STATEMENTS: `/jetcards/${JETCARD_LIST_TABS.STATEMENTS}`,
  AIRPORTS_FBOS_LIST: '/fbo-list/:id/fbos/:airportName/:airportCode',
  CONTACT_DETAILS: '/contact/:contactId',
  CONTACT_DETAILS_TRIPS_TAB: `/contact/:contactId/${CONTACT_DETAILS_TAB_LIST.TRIPS}`,
  CONTACT_DETAILS_JETCARD_TAB: `/contact/:contactId/${CONTACT_DETAILS_TAB_LIST.JET_CARDS}`,
  CONTACT_DETAILS_JETCARD_TAB_WITH_ID: `/contact/:contactId/${CONTACT_DETAILS_TAB_LIST.JET_CARDS}/:jetCardId`,
  CONTACT_DETAILS_FLIGHT_CREDITS_TAB: `/contact/:contactId/${CONTACT_DETAILS_TAB_LIST.FLIGHT_CREDITS}`,
  CONTACT_DETAILS_PASSENGERS_TAB: `/contact/:contactId/${CONTACT_DETAILS_TAB_LIST.PASSENGERS}`,
  CONTACT_DETAILS_PETS_TAB: `/contact/:contactId/${CONTACT_DETAILS_TAB_LIST.PETS}`,
  CONTACT_DETAILS_TASKS_TAB: `/contact/:contactId/${CONTACT_DETAILS_TAB_LIST.TASKS}`,
  CONTACT_DETAILS_NOTES_TAB: `/contact/:contactId/${CONTACT_DETAILS_TAB_LIST.NOTES}`,
  ACCOUNT_DETAILS: '/account/:accountId',
  ACCOUNT_DETAILS_TRIPS_TAB: `/account/:accountId/${ACCOUNT_DETAILS_TAB_LIST.TRIPS}`,
  ACCOUNT_DETAILS_JETCARD_TAB: `/account/:accountId/${ACCOUNT_DETAILS_TAB_LIST.JET_CARDS}`,
  ACCOUNT_DETAILS_FLIGHT_CREDITS_TAB: `/account/:accountId/${ACCOUNT_DETAILS_TAB_LIST.FLIGHT_CREDITS}`,
  ACCOUNT_DETAILS_PASSENGERS_TAB: `/account/:accountId/${ACCOUNT_DETAILS_TAB_LIST.PASSENGERS}`,
  ACCOUNT_DETAILS_PETS_TAB: `/account/:accountId/${ACCOUNT_DETAILS_TAB_LIST.PETS}`,
  ACCOUNT_DETAILS_TASKS_TAB: `/account/:accountId/${ACCOUNT_DETAILS_TAB_LIST.TASKS}`,
  ACCOUNT_DETAILS_NOTES_TAB: `/account/:accountId/${ACCOUNT_DETAILS_TAB_LIST.NOTES}`,
  TRIP: '/trip',
  CALENDAR: '/calendar',
  CALENDAR_SEVEN_DAYS: `/calendar/${CALENDAR_VIEW_PATH[CALENDAR_VIEW.SEVEN_DAYS]}`,
  CALENDAR_WEEK: `/calendar/${CALENDAR_VIEW_PATH[CALENDAR_VIEW.WEEK]}`,
  CALENDAR_MONTH: `/calendar/${CALENDAR_VIEW_PATH[CALENDAR_VIEW.MONTH]}`,
  CALENDAR_VIEW_ROUTE: '/calendar/:view',
  TRIP_DETAILS: '/trip/:tripId',
  TRIP_DETAILS_PASSENGERS_TAB: `/trip/:tripId/${TRIP_DETAILS_TAB_LIST.PASSENGERS}`,
  TRIP_DETAILS_FINANCES_TAB: `/trip/:tripId/${TRIP_DETAILS_TAB_LIST.FINANCES}`,
  TRIP_DETAILS_TASKS_TAB: `/trip/:tripId/${TRIP_DETAILS_TAB_LIST.TASKS}`,
  TRIP_DETAILS_NOTES_TAB: `/trip/:tripId/${TRIP_DETAILS_TAB_LIST.NOTES}`,
  TRIP_DETAILS_TRIP_REPORTS_TAB: `/trip/:tripId/${TRIP_DETAILS_TAB_LIST.TRIP_REPORTS}`,
  TRIP_DETAILS_ACTIVITY_HISTORY_TAB: `/trip/:tripId/${TRIP_DETAILS_TAB_LIST.ACTIVITY_HISTORY}`,
  CREATE_TRIP: '/trip/create-trip',
  EDIT_TRIP: '/trip/:tripId/edit',
  TRIP_PROPOSAL_PREVIEW_BROKER: '/trip/:tripId/proposal/preview',
  TRIP_PROPOSAL_PREVIEW_CLIENT: '/trip/:tripId/:hash/proposal-review',
  TRIP_PROPOSAL_PREVIEW_CLIENT_RECIPIENT: '/trip/:tripId/:hash/proposal-review-recipient',
  TRIP_PROPOSAL_PRELIMINARY_INVOICE_CLIENT: '/trip/:tripId/:hash/preliminary-invoice',
  TRIP_PROPOSAL_INVOICE_CLIENT: '/trip/:tripId/:hash/invoice',
  TRIP_FEEDBACK_CLIENT: '/trip/feedback/:hash',
  TRIP_FEEDBACK_BROKER: '/trip/:tripId/feedback',
  MANAGE_TRIP: '/trip/manage-trip/:tripId',
  FINANCE: '/finance',
  FINANCE_OPERATOR_PAYMENT: '/finance/operator-payment',
  TASKS: '/tasks',
  TASKS_TEMPLATES: `/tasks/${TASK_LIST_TABS.TEMPLATES}`,
  TASKS_TEMPLATE_NEW: `/tasks/${TASK_LIST_TABS.TEMPLATES}/new`,
  TASKS_TEMPLATE_EDIT: `/tasks/${TASK_LIST_TABS.TEMPLATES}/:id`,
  FLIGHTS: '/flights',
  TRIP_REPORTS: '/trip-reports',
  TRIP_REPORT_DETAILS: '/trip-report/:tripReportId',
};

export const buildURL = (url: string, params: Record<string, any>) => {
  Object.keys(params).forEach(k => {
    url = url.replace(`:${k}`, params[k]);
  });
  return url;
};
